import { render, staticRenderFns } from "./addMonitorPoint.vue?vue&type=template&id=0aa3cc52&scoped=true"
import script from "./addMonitorPoint.vue?vue&type=script&lang=js"
export * from "./addMonitorPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3cc52",
  null
  
)

export default component.exports